import { render, staticRenderFns } from "./CurrencyPerValue.vue?vue&type=template&id=36b039ea"
import script from "./CurrencyPerValue.vue?vue&type=script&lang=js"
export * from "./CurrencyPerValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports